import { headSnippet, noscriptSnippet } from './head-snippet';
import { init, showPreferences } from './init';
import { normalizeConfig } from './types';

export { headSnippet, noscriptSnippet, init, showPreferences, normalizeConfig };
export type { ConsentConfig, ConsentColors, ConsentCategories } from './types';

// Self-initialize for the WordPress adapter. The plugin sets `window.__ommaticConsent`
// and calls `OmmaticConsent.init()` from an inline script placed AFTER the bundle.
// Under JS optimizers (e.g. WP Rocket "Delay JavaScript Execution") the load order is
// reshuffled: the inline call can run BEFORE this bundle is defined, hit its
// `if (window.OmmaticConsent)` guard, and silently no-op — so no banner ever shows.
// To be robust to ANY order, when this bundle loads and a config is already present,
// we init ourselves. init() is idempotent, so the inline call + this never double-run.
if (typeof window !== 'undefined') {
  const cfg = (window as unknown as { __ommaticConsent?: unknown }).__ommaticConsent;
  if (cfg) {
    init(cfg as never);
  }
}
